import React from 'react';

export default class extends React.PureComponent {
  handleClick = (e) => {
    const { index, onClick } = this.props; 
    // console.log('Thumbnail Click', index);
    onClick(index);
  } 
  render() {
    const { index, src, thumbnail, active } = this.props;
    const url = thumbnail ? thumbnail : src;
    return (
      <div
        className={`thumbnail ${active ? 'active' : ''}`}
        index={index}
        onClick={this.handleClick}
      >
        <div style={{ backgroundImage: 'url("' + url + '")' }} />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/GalleryLightbox/components/Thumbnail.js